import React from "react";
import "../assets/styles/_static-kv.scss";

type Props = {
  title: "column" | "contact" | "news" | "privacy" | "privacy-sp" | "company";
};

export const StaticKv = (props: Props) => {
  return (
    <div className="static-kv">
      <h2 className="kv-title">
        <img
          src={`../images/title/${props.title}.png`}
          alt=""
          className={props.title}
        />
      </h2>
    </div>
  );
};
